import Cookies from 'js-cookie';
import axios from 'axios';
import { adminMainUrl } from '../../../Config';

// organsation list
export const fetchOrganisationListRequest = () => ({
    type: "FIND_ORGANISATION_LIST_REQUEST",
});

export const fetchOrganisationListSuccess = (data) => ({
    type: "FIND_ORGANISATION_LIST_SUCCESS",
    payload: data,
});

export const fetchOrganisationListFailure = (error) => ({
    type: "FIND_ORGANISATION_LIST_FAILURE",
    payload: error,
});

export const getOrganisationList = () => {
    return async function (dispatch) {
        dispatch(fetchOrganisationListRequest());
        const token = Cookies.get('token');
        let config = {
            method: "GET",
            headers: {
                'auth-token': token,
                'user_id': Cookies.get("flexichain_user_id"),
                'Content-Type': 'application/json',
            }
        };

        const apiUrl = `${adminMainUrl}/api/organization/list`;

        try {
            axios(apiUrl, config).then((res) => {
                dispatch(fetchOrganisationListSuccess(res.data?.data));
            }).catch((err) => {
                console.log("ERROR in getOrganisationList function (redux):", err);
                dispatch(fetchOrganisationListFailure(err));
            });
        } catch (error) {
            console.log("Unexpected error in getOrganisationList function:", error);
            dispatch(fetchOrganisationListFailure(error));
        }
    };
};

// organsation list

// organsation view
export const fetchOrganisationDetailRequest = () => ({
    type: "FIND_ORGANISATION_DETAIL_REQUEST",
});

export const fetchOrganisationDetailSuccess = (data) => ({
    type: "FIND_ORGANISATION_DETAIL_SUCCESS",
    payload: data,
});

export const fetchOrganisationDetailFailure = (error) => ({
    type: "FIND_ORGANISATION_DETAIL_FAILURE",
    payload: error,
});

export const getOrganisationDetail = (id) => {
    return async function (dispatch) {
        dispatch(fetchOrganisationDetailRequest());
        const token = Cookies.get('token');
        let config = {
            method: "GET",
            headers: {
                'auth-token': token,
                'user_id': Cookies.get("flexichain_user_id"),
                'Content-Type': 'application/json',
            }
        };

        const apiUrl = `${adminMainUrl}/api/organization/view`;
        const body = { id: id }
        try {
            axios.post(apiUrl, body, config).then((res) => {
                dispatch(fetchOrganisationDetailSuccess(res.data?.data));
            }).catch((err) => {
                console.log("ERROR in getOrganisationDetail function (redux):", err);
                dispatch(fetchOrganisationDetailFailure(err));
            });
        } catch (error) {
            console.log("Unexpected error in getOrganisationDetail function:", error);
            dispatch(fetchOrganisationDetailFailure(error));
        }
    };
};

// organsation view


// organsation list
export const fetchEmployeeListRequest = () => ({
    type: "FIND_EMPLOYEE_LIST_REQUEST",
});

export const fetchEmployeeListSuccess = (data) => ({
    type: "FIND_EMPLOYEE_LIST_SUCCESS",
    payload: data,
});

export const fetchEmployeeListFailure = (error) => ({
    type: "FIND_EMPLOYEE_LIST_FAILURE",
    payload: error,
});

export const getEmployeeList = () => {
    return async function (dispatch) {
        dispatch(fetchEmployeeListRequest());
        const token = Cookies.get('token');
        // let config = {
        //     // method: "GET",
        //     headers: {
        //         'auth-token': token,
        //         'user_id': Cookies.get("flexichain_user_id"),
        //         'Content-Type': 'application/json',
        //     }
        // };

        const apiUrl = `${adminMainUrl}/api/employee-list`;

        try {
            axios.get(apiUrl).then((res) => {
                dispatch(fetchEmployeeListSuccess(res.data?.data));
            }).catch((err) => {
                console.log("ERROR in getEmployeeList function (redux):", err);
                dispatch(fetchEmployeeListFailure(err));
            });
        } catch (error) {
            console.log("Unexpected error in getEmployeeList function:", error);
            dispatch(fetchEmployeeListFailure(error));
        }
    };
};

// organsation list


// organsation iata list
export const fetchOrganisationIATAListRequest = () => ({
    type: "FIND_ORGANISATION_IATA_LIST_REQUEST",
});

export const fetchOrganisationIATAListSuccess = (data) => ({
    type: "FIND_ORGANISATION_IATA_LIST_SUCCESS",
    payload: data,
});

export const fetchOrganisationIATAListFailure = (error) => ({
    type: "FIND_ORGANISATION_IATA_LIST_FAILURE",
    payload: error,
});

export const getOrganisationIATAList = (token, user_id, id) => {
    return async function (dispatch) {
        dispatch(fetchOrganisationIATAListRequest());
        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };

        const apiUrl = `${adminMainUrl}/api/organization/iata/list`;
        let body = { customer_id: id }
        try {
            axios.post(apiUrl, body, config).then((res) => {
                dispatch(fetchOrganisationIATAListSuccess(res.data?.data));
            }).catch((err) => {
                console.log("ERROR in getOrganisationIATAList function (redux):", err);
                dispatch(fetchOrganisationIATAListFailure(err));
            });
        } catch (error) {
            console.log("Unexpected error in getOrganisationIATAList function:", error);
            dispatch(fetchOrganisationIATAListFailure(error));
        }
    };
};

// organsation iata list


// organsation iata detail
export const fetchOrganisationIATADetailRequest = () => ({
    type: "FIND_ORGANISATION_IATA_DETAIL_REQUEST",
});

export const fetchOrganisationIATADetailSuccess = (data) => ({
    type: "FIND_ORGANISATION_IATA_DETAIL_SUCCESS",
    payload: data,
});

export const fetchOrganisationIATADetailFailure = (error) => ({
    type: "FIND_ORGANISATION_IATA_DETAIL_FAILURE",
    payload: error,
});

export const getOrganisationIATADetail = (token, user_id, id) => {
    return async function (dispatch) {
        dispatch(fetchOrganisationIATADetailRequest());
        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };

        const apiUrl = `${adminMainUrl}/api/organization/iata/view?id=${id}`;

        try {
            axios.get(apiUrl, config).then((res) => {
                dispatch(fetchOrganisationIATADetailSuccess(res.data?.data));
            }).catch((err) => {
                console.log("ERROR in getOrganisationIATADetail function (redux):", err);
                dispatch(fetchOrganisationIATADetailFailure(err));
            });
        } catch (error) {
            console.log("Unexpected error in getOrganisationIATADetail function:", error);
            dispatch(fetchOrganisationIATADetailFailure(error));
        }
    };
};

// organsation iata detail


// iata airline list
export const fetchIATAAirlineRequest = () => ({
    type: "FIND_IATA_AIRLINE_REQUEST",
});

export const fetchIATAAirlineSuccess = (data) => ({
    type: "FIND_IATA_AIRLINE_SUCCESS",
    payload: data,
});

export const fetchIATAAirlineFailure = (error) => ({
    type: "FIND_IATA_AIRLINE_FAILURE",
    payload: error,
});

export const getIATAAirline = () => {
    return async function (dispatch) {
        dispatch(fetchIATAAirlineRequest());
        const token = Cookies.get('token');
        // let config = {
        //     // method: "GET",
        //     headers: {
        //         'auth-token': token,
        //         'user_id': Cookies.get("flexichain_user_id"),
        //         'Content-Type': 'application/json',
        //     }
        // };

        const apiUrl = `${adminMainUrl}/api/airline/get`;

        try {
            axios.get(apiUrl).then((res) => {
                dispatch(fetchIATAAirlineSuccess(res.data?.data));
            }).catch((err) => {
                console.log("ERROR in getIATAAirline function (redux):", err);
                dispatch(fetchIATAAirlineFailure(err));
            });
        } catch (error) {
            console.log("Unexpected error in getIATAAirline function:", error);
            dispatch(fetchIATAAirlineFailure(error));
        }
    };
};

// iata airline list



// organsation reg list
export const fetchOrganisationREGListRequest = () => ({
    type: "FIND_ORGANISATION_REG_LIST_REQUEST",
});

export const fetchOrganisationREGListSuccess = (data) => ({
    type: "FIND_ORGANISATION_REG_LIST_SUCCESS",
    payload: data,
});

export const fetchOrganisationREGListFailure = (error) => ({
    type: "FIND_ORGANISATION_REG_LIST_FAILURE",
    payload: error,
});

export const getOrganisationREGList = (token, user_id, id) => {
    return async function (dispatch) {
        dispatch(fetchOrganisationREGListRequest());
        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };

        const apiUrl = `${adminMainUrl}/api/organization/reg/list`;
        let body = { customer_id: id }
        try {
            axios.post(apiUrl, body, config).then((res) => {
                dispatch(fetchOrganisationREGListSuccess(res.data?.data));
            }).catch((err) => {
                console.log("ERROR in getOrganisationREGList function (redux):", err);
                dispatch(fetchOrganisationREGListFailure(err));
            });
        } catch (error) {
            console.log("Unexpected error in getOrganisationREGList function:", error);
            dispatch(fetchOrganisationREGListFailure(error));
        }
    };
};

// organsation iata list


// organsation iata detail
export const fetchOrganisationREGDetailRequest = () => ({
    type: "FIND_ORGANISATION_REG_DETAIL_REQUEST",
});

export const fetchOrganisationREGDetailSuccess = (data) => ({
    type: "FIND_ORGANISATION_REG_DETAIL_SUCCESS",
    payload: data,
});

export const fetchOrganisationREGDetailFailure = (error) => ({
    type: "FIND_ORGANISATION_REG_DETAIL_FAILURE",
    payload: error,
});

export const getOrganisationREGDetail = (token, user_id, id) => {
    return async function (dispatch) {
        dispatch(fetchOrganisationREGDetailRequest());
        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };

        const apiUrl = `${adminMainUrl}/api/organization/iata/view?id=${id}`;

        try {
            axios.get(apiUrl, config).then((res) => {
                dispatch(fetchOrganisationREGDetailSuccess(res.data?.data));
            }).catch((err) => {
                console.log("ERROR in getOrganisationREGDetail function (redux):", err);
                dispatch(fetchOrganisationREGDetailFailure(err));
            });
        } catch (error) {
            console.log("Unexpected error in getOrganisationREGDetail function:", error);
            dispatch(fetchOrganisationREGDetailFailure(error));
        }
    };
};

// organsation iata detail


//organisation all final Quotation Details
export const getCompanyAllFinalQuotation = (token, user_id, company_id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_COMPANY_FINAL_QUOTATION_LIST_REQUEST",
        });
        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };

        const apiUrl = `${adminMainUrl}/api/organization/customer-quotation-list`;
        const body = { customer_id: company_id }
        try {
            axios.post(apiUrl, body, config).then((res) => {
                dispatch({
                    type: "FIND_COMPANY_FINAL_QUOTATION_LIST_SUCCESS",
                    payload: res?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getCompanyAllFinalQuotation function (redux):", err);
                dispatch({
                    type: "FIND_COMPANY_FINAL_QUOTATION_LIST_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getCompanyAllFinalQuotation function:", error);
            dispatch({
                type: "FIND_COMPANY_FINAL_QUOTATION_LIST_FAILURE",
                payload: error,
            });
        }
    };
};
//organisation all final Quotation Details

// agent options
export const getOrganisationAgentList = (token, user_id, company_id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_ORGANISATION_AGENT_REQUEST",
        });
        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };

        const apiUrl = `${adminMainUrl}/api/organization/get-all-agents-except-id?customer_id=${company_id}`;
        try {
            axios.get(apiUrl, config).then((res) => {
                dispatch({
                    type: "FIND_ORGANISATION_AGENT_SUCCESS",
                    payload: res?.data.data,
                });
            }).catch((err) => {
                console.log("ERROR in getOrganisationAgentList function (redux):", err);
                dispatch({
                    type: "FIND_ORGANISATION_AGENT_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getOrganisationAgentList function:", error);
            dispatch({
                type: "FIND_ORGANISATION_AGENT_FAILURE",
                payload: error,
            });
        }
    };
};
// agent options